import BaseAPI from './base'
/**
 * API xử lý nghiệp vụ làm bài
 */
class SubmitDetailAPI extends BaseAPI {}

export default new SubmitDetailAPI('v1/submit-details', 'SubmitDetail')
